<script>

</script>

<div class="flex flex-grow flex-col items-center lg:mx-14 xl:mx-20 2xl:mx-40 pb-10">
<slot></slot>   
</div>